import React, { useState } from "react";
import Header from "./Header";
import GenrePanel from "./GenrePanel";
import Dashboard from "./Dashboard";
import Grid  from "@mui/material/Grid";

const Landing = () => {
  const [genre, setGenre] = useState(["All"]);
  const [rating, setRating] = useState(["Any"]);
  const [sortBy, setSortBy] = useState("Release Date");
  const [search, setSearch] = useState(null);

  return (
    <>
      <Header
        hiddenNavbar
        search={search}
        setSearch={setSearch}
      />
      <GenrePanel
        genre={genre}
        setGenre={setGenre}
        rating={rating}
        setRating={setRating}
        sortBy={sortBy}
        setSortBy={setSortBy}
      />

      <Grid container p={1}>
        <Grid item xs={1}></Grid>
        <Grid item xs={10}>
          <Dashboard
            genre={genre}
            rating={rating}
            sortBy={sortBy}
            search={search}
          />
        </Grid>
        <Grid item xs={1}></Grid>
      </Grid>
    </>
  );
};

export default Landing;
